import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { AppSettings } from './enums/app-settings.enum';
import { ApplicationInitializationService } from './services/application-initialization.service';
import { LanguageSwitchService } from './services/language-switch.service';
import { UtilitiesService } from './utilities/utilities.service';
declare let ga: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  title = 'addons';
  loaderColor: string = AppSettings.LOADER_COLOR;
  URLS: any;
  constructor(
    private router: Router,
    private translate: TranslateService,
    private UTS: UtilitiesService,
    // private gtmService: GoogleTagManagerService,
    private route: ActivatedRoute,
    private LSS: LanguageSwitchService,
    private R:Renderer2,
    private applicationInitializationService: ApplicationInitializationService
  ) {
    this.UTS.log('BUILD 0.0.6 DEPLOYED 05-02-2024 CQT CHANGE SPECIAL CHARACTER FIX');
    this.route.queryParamMap.subscribe((params) => {
      const token: any = { ...params };
      const parentLanguage = localStorage.getItem('curr_language');
      const parentLang =  (parentLanguage)? parentLanguage.toLocaleLowerCase() : 'english';
        localStorage.removeItem('language');
      const localLanguage = localStorage.getItem('language');
      const lang = token.params.locale
        ? token.params.locale.toLowerCase()
        : token.params.lang
        ? token.params.lang.toLowerCase() : (localLanguage)? localLanguage.toLocaleLowerCase() : 'en';
        
      if (lang === 'ar' || parentLang === 'arabic') {
        this.LSS.setLanguage('ar');
        this.LSS.changeLanguage();
        this.UTS.setAHURL(`ar${AppSettings.APPLICATION_HEADER_URL}`);
        this.UTS.setAFURL(`ar${AppSettings.APPLICATION_FOOTER_URL}`);
        this.UTS.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
      } else {
        this.LSS.setLanguage('en');
        this.LSS.changeLanguage();
        this.UTS.setAHURL(`en${AppSettings.APPLICATION_HEADER_URL}`);
        this.UTS.setAFURL(`en${AppSettings.APPLICATION_FOOTER_URL}`);
        this.UTS.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
      }
    });
    // this.UTS.getSelectedLanguage().then(res=>{
    //   this.URLS = res
    // })
  }
  ngOnInit() {
    this.loadScript(this.applicationInitializationService?.environmentConfig?.ADOBE_SCRIPT);
  }
  ngAfterViewInit() {
    this.UTS.getHeaders();
    setTimeout(() => {
      this.setPageOritentation(this.LSS.getLanguage())
    }, 500);
  }
  ngOnDestroy() {
    this.destroy$.next();
  }

  public getHeaderURL() {
    return this.UTS.getAHURL();
  }

  public getFooterURL() {
    return this.UTS.getAFURL();
  }
  public getNavigationURL() {
    return this.UTS.getANURL();
  }
  
  setPageOritentation(lang){
    if (lang === 'en') {
      this.R.setAttribute(document.documentElement, 'lang','en');
      this.R.setAttribute(document.body, 'dir','ltr');
    }else{
      this.R.setAttribute(document.documentElement, 'lang','ar');
      this.R.setAttribute(document.body, 'dir','rtl');
    }
  }
  loadScript(src: string) {
    return new Promise((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      script.async = true;
      document.getElementsByTagName('body')[0].appendChild(script);
      resolve("");
    });
  }
}
